// Constantes globales del dashboard UC Christus

export const STAGE_COLORS = {
  busqueda: "#7C3AED",
  agendamiento: "#8B5CF6",
  confirmacion: "#6366F1",
  admision: "#3B82F6",
  consulta: "#06B6D4",
  laboratorio: "#14B8A6",
  imagen: "#10B981",
  procedimientos: "#22C55E",
  cirugia: "#84CC16",
  hospitalizacion: "#F59E0B",
  urgencia: "#F97316",
  farmacia: "#EF4444",
  pago: "#EC4899",
  seguimiento: "#F43F5E",
  programa_cronico: "#D946EF",
  relacion_comercial: "#64748B",
};

export const STAGE_LIST = [
  { id: 1, key: "busqueda", nombre: "Búsqueda y Decisión", color: STAGE_COLORS.busqueda, desc: "Paciente busca en la web, compara, cotiza" },
  { id: 2, key: "agendamiento", nombre: "Agendamiento", color: STAGE_COLORS.agendamiento, desc: "Reserva hora (web, app, call center, presencial)" },
  { id: 3, key: "confirmacion", nombre: "Confirmación y Recordatorio", color: STAGE_COLORS.confirmacion, desc: "Recibe email/WhatsApp de confirmación" },
  { id: 4, key: "admision", nombre: "Admisión y Llegada", color: STAGE_COLORS.admision, desc: "Llega al centro, tótem, admisión, pago copago" },
  { id: 5, key: "consulta", nombre: "Consulta Médica", color: STAGE_COLORS.consulta, desc: "Atención con el profesional" },
  { id: 6, key: "laboratorio", nombre: "Exámenes de Laboratorio", color: STAGE_COLORS.laboratorio, desc: "Toma de muestra, resultados" },
  { id: 7, key: "imagen", nombre: "Exámenes de Imagen", color: STAGE_COLORS.imagen, desc: "Radiografía, scanner, resonancia" },
  { id: 8, key: "procedimientos", nombre: "Procedimientos", color: STAGE_COLORS.procedimientos, desc: "Endoscopía, biopsia, etc." },
  { id: 9, key: "cirugia", nombre: "Cirugía y Pabellón", color: STAGE_COLORS.cirugia, desc: "Presupuesto → cirugía → recuperación" },
  { id: 10, key: "hospitalizacion", nombre: "Hospitalización", color: STAGE_COLORS.hospitalizacion, desc: "Admisión → cama → cuidados → alta" },
  { id: 11, key: "urgencia", nombre: "Urgencia", color: STAGE_COLORS.urgencia, desc: "Llegada → triage → atención → destino" },
  { id: 12, key: "farmacia", nombre: "Farmacia y Medicamentos", color: STAGE_COLORS.farmacia, desc: "Receta → dispensación → administración" },
  { id: 13, key: "pago", nombre: "Pago y Financiamiento", color: STAGE_COLORS.pago, desc: "Bono, copago, seguro, plan de pago" },
  { id: 14, key: "seguimiento", nombre: "Seguimiento Post-Atención", color: STAGE_COLORS.seguimiento, desc: "Control, encuesta, llamada telefónica" },
  { id: 15, key: "programa_cronico", nombre: "Programa Crónico", color: STAGE_COLORS.programa_cronico, desc: "Diálisis, oncología, pediatría" },
  { id: 16, key: "relacion_comercial", nombre: "Relación Comercial", color: STAGE_COLORS.relacion_comercial, desc: "Plan de salud, CRM, fidelización" },
];

export const JOURNEY_TYPES = [
  { key: "global", label: "Global", color: "#7C3AED" },
  { key: "ambulatorio", label: "Ambulatorio", color: "#8B5CF6" },
  { key: "hospitalario", label: "Hospitalario", color: "#F59E0B" },
  { key: "urgencia", label: "Urgencia", color: "#F97316" },
  { key: "cobranzas", label: "Cobranzas", color: "#10B981" },
];

export const CENTROS = [
  "Todos los centros",
  "CMSJ San Joaquín",
  "Hospital Clínico UC",
  "CM Lira",
  "CM Escuela Militar",
  "Clínica San Carlos de Apoquindo",
  "CM Santa Lucía",
  "CM Marcoleta",
];

export const ESPECIALIDADES = [
  "Todas las especialidades",
  "Medicina Familiar",
  "Cardiología",
  "Oftalmología",
  "Pediatría",
  "Ginecología y Obstetricia",
  "Traumatología",
  "Dermatología",
  "Neurología",
  "Endocrinología",
  "Otorrinolaringología",
  "Medicina General",
];

export const PREVISIONES = ["Todas", "FONASA", "ISAPRE Colmena", "ISAPRE Banmédica", "ISAPRE Cruz Blanca", "ISAPRE Consalud", "ISAPRE Vida Tres", "ISAPRE Nueva Masvida"];

export const PERIODOS = [
  "Abril 2026",
  "Marzo 2026",
  "Q1 2026",
  "Q4 2025",
  "Últimos 6 meses",
  "Últimos 12 meses",
];

export const formatNum = (n) => {
  if (n == null) return "—";
  return new Intl.NumberFormat("es-CL").format(n);
};

export const formatPct = (n, digits = 1) => {
  if (n == null) return "—";
  return `${Number(n).toFixed(digits)}%`;
};

// ============================================================
// COHORTE — Constantes para segmentación y estimador de costos
// ============================================================

export const ETAPAS_COHORTE = [
  { key: "busqueda", nombre: "Búsqueda", color: "#7C3AED" },
  { key: "agendamiento", nombre: "Agendamiento", color: "#8B5CF6" },
  { key: "cancelado", nombre: "Cancelado", color: "#EF4444" },
  { key: "no_show", nombre: "No-show", color: "#F97316" },
  { key: "atendido", nombre: "Atendido", color: "#06B6D4" },
  { key: "con_indicacion", nombre: "Con Indicación", color: "#14B8A6" },
  { key: "lab_pendiente", nombre: "Lab Pendiente", color: "#F59E0B" },
  { key: "lab_realizado", nombre: "Lab Realizado", color: "#10B981" },
  { key: "imagen_pendiente", nombre: "Imagen Pendiente", color: "#F59E0B" },
  { key: "imagen_realizada", nombre: "Imagen Realizada", color: "#10B981" },
  { key: "cirugia_pendiente", nombre: "Cirugía Pendiente", color: "#F59E0B" },
  { key: "cirugia_realizada", nombre: "Cirugía Realizada", color: "#84CC16" },
  { key: "pago_registrado", nombre: "Pago Registrado", color: "#EC4899" },
];

export const RANGOS_EDAD = ["0-17", "18-29", "30-44", "45-59", "60-74", "75+"];

export const PREVISIONES_DETALLE = [
  "FONASA",
  "ISAPRE Colmena",
  "ISAPRE Banmédica",
  "ISAPRE Cruz Blanca",
  "ISAPRE Consalud",
  "ISAPRE Vida Tres",
  "ISAPRE Nueva Masvida",
  "ISAPRE Isalud",
  "Sin información",
];

export const PLANES_UC = ["SP", "SC", "HQ", "DU", "SI", "247", "CM", "CC", "CE", "SPE", "SCE"];

export const formatCLP = (n) => {
  if (n == null) return "—";
  return `$${new Intl.NumberFormat("es-CL").format(n)}`;
};
